import axios from "axios";

function numberOrLots(number) {
  if (number > 99) {
    return "99+";
  }
  return number;
}

export default {
  state: {
    counts: {
      notifications: 0,
      resources: 0,
      community: 0,
      journeys: 0
    }
  },
  mutations: {
    setHeaderCounts(state, counts) {
      state.counts = counts;
    },
    clearNotificationCount(state) {
      state.counts.notifications = 0;
    },
    clearJourneysCount(state) {
      state.counts.journeys = 0;
    }
  },
  actions: {
    async fetchNotificationCount({ commit }) {
      let resp = await axios.get("/programs/api/activity/count");
      let counts = resp.data;
      commit("setHeaderCounts", counts);
    }
  },
  getters: {
    notificationCount(state) {
      return numberOrLots(state.counts.notifications);
    },
    newResourceCount(state) {
      return numberOrLots(state.counts.resources);
    },
    newPostCount(state) {
      return numberOrLots(state.counts.community);
    },
    newJourneysCount(state) {
      return numberOrLots(state.counts.journeys)
    }
  }
};
